// Theme constants
export const THEME_URL = empower_options.themeUrl;
export const SITE_URL = empower_options.siteUrl;
